import '@/modules/system/auth/presentation/pages/escolha-modulo.css';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Links from '@/shared/constants/navegacao';
import { GetDiretoriaDoUsuario } from '@/modules/structure/diretoria/diretoria.service';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import RelatoriosUserLabel from '@/modules/reports/presentation/components/RelatoriosUserLabel';
import { ToastContainer } from 'react-toastify';
import { LuScrollText, LuScale, LuGavel, LuLogOut } from 'react-icons/lu';

type CardLinkProps = {
  title: string;
  description: string;
  to?: string;
  onClick?: () => void;
  icon: React.ReactNode;
  disabled?: boolean;
};

function CardLink({ title, description, to, onClick, disabled, icon }: CardLinkProps) {
  const body = (
    <button
      type="button"
      className="escolha-modulo-card"
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
      aria-describedby="escolha-relatorios"
    >
      <span className="escolha-modulo-card-icon">{icon}</span>
      <span className="escolha-modulo-card-body">
        <span className="escolha-modulo-card-title">{title}</span>
        <p className="escolha-modulo-card-desc">{description}</p>
      </span>
    </button>
  );

  if (disabled || !to) return body;
  return (
    <Link to={to} className="text-decoration-none">
      {body}
    </Link>
  );
}

export default function RelatoriosMenuPage() {
  const [hasDiretoria, setHasDiretoria] = useState(false);
  const { permissions } = useNavigationView();

  const canDiretoria = hasDiretoria || permissions.relatoriosDiretoria;
  const canCorregedoria = permissions.relatoriosCorregedoria;

  useEffect(() => {
    GetDiretoriaDoUsuario()
      .then((diretoria) => setHasDiretoria(!!diretoria))
      .catch(() => setHasDiretoria(false));
  }, []);

  return (
    <>
      <ToastContainer position="top-center" />
      <section className="ftco-section">
        <div className="loginrow w-100 justify-content-center">
          <div className="escolha-modulo-wrap">
            <header className="escolha-modulo-heading">
              <h2>Relatórios de Atividades</h2>
              <RelatoriosUserLabel />
              <div className="d-flex align-items-start justify-content-between gap-2">
                <p id="escolha-relatorios" className="mb-0">
                  Selecione abaixo a área do módulo que deseja acessar nesta sessão.
                </p>
                <a href={Links.Auth_Logout} className="escolha-modulo-logout" title="Sair">
                  <LuLogOut size={18} strokeWidth={1.9} aria-hidden />
                  Sair
                </a>
              </div>
            </header>

            <ul className="escolha-modulo-grid">
              {permissions.relatoriosAtividades && (
                <li>
                  <CardLink
                    title="Meus Relatórios"
                    description="Criar, editar e enviar seus relatórios mensais."
                    to={Links.Relatorios_Meus}
                    icon={<LuScrollText size={42} strokeWidth={1.35} aria-hidden />}
                  />
                </li>
              )}
              {canDiretoria &&
                <li>
                  <CardLink
                    title="Diretoria Regional"
                    description={canDiretoria ? 'Aprovação/reprovação dos relatórios na diretoria.' : 'Sem permissão para acessar.'}
                    to={Links.Relatorios_Aprovacao}
                    disabled={!canDiretoria}
                    icon={<LuScale size={44} strokeWidth={1.35} aria-hidden />}
                  />
                </li>
              }
              {canCorregedoria &&
                <li>
                  <CardLink
                    title="Corregedoria"
                    description={canCorregedoria ? 'Aval final e tramitação na Corregedoria.' : 'Sem permissão para acessar.'}
                    to={Links.Relatorios_Corregedoria}
                    disabled={!canCorregedoria}
                    icon={<LuGavel size={44} strokeWidth={1.35} aria-hidden />}
                  />
                </li>
              }
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

